import { render, staticRenderFns } from "./placard.vue?vue&type=template&id=2d843de7&"
import script from "./placard.vue?vue&type=script&lang=js&"
export * from "./placard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports